document.addEventListener("click", async (e) => {
  const button = e.target.closest("#share-cart-btn");

  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  const originalHtml = button.innerHTML;

  try {
    button.disabled = true;
    button.innerHTML = "Sharing...";

    const cartResponse = await fetch("/cart.js", {
      credentials: "same-origin"
    });

    if (!cartResponse.ok) {
      throw new Error("Unable to read cart");
    }

    const cart = await cartResponse.json();

    if (!cart.items || cart.items.length === 0) {
      alert("Your cart is empty.");
      return;
    }

    const response = await fetch(
      "https://urwizards-share-cart.tysonyu774.workers.dev/save",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: cart.items
        })
      }
    );

    const data = await response.json();

    if (!response.ok || !data.token) {
      console.error("Share cart worker error:", data);
      alert(data.error || "Failed to create share link");
      return;
    }

    const shareUrl =
      window.location.origin +
      "/pages/share-cart?token=" +
      data.token;

    const shareTitle = "Shared Cart";
    const shareText = "I shared my cart with you.";

    /*
      Mobile first:
      iPhone / Android 优先使用系统分享面板
    */
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        });

        return;
      } catch (shareError) {
        /*
          用户取消分享时，不算真正失败
        */
        console.warn("Native share cancelled or failed:", shareError);
      }
    }

    /*
      Desktop / fallback:
      尝试复制到剪贴板
    */
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(shareUrl);

        alert(
          "Share link copied!\n\n" +
          shareUrl
        );

        return;
      } catch (clipboardError) {
        console.warn("Clipboard copy failed:", clipboardError);
      }
    }

    /*
      最后兜底：
      手机无法复制时，让用户手动复制
    */
    window.prompt(
      "Copy this share link:",
      shareUrl
    );

  } catch (err) {
    console.error("Share cart error:", err);

    alert(
      "Unable to create share link. Please try again."
    );
  } finally {
    button.disabled = false;
    button.innerHTML = originalHtml;
  }
});